const fetchAs = require("./fetchAs");
const findQueryParameter = require("./findQueryParameter");
const findIfRestrictedStatic = require("./findIfRestrictedStatic");

/**
 *
 * Find if a page has restricted access
 *
 * @param nid: Entity numeric id
 * @param location: Browser address information
 * @returns
 */
module.exports = async function findIfRestricted(pageData, location) {
	const { nid } = pageData;
	let isRestricted = findIfRestrictedStatic(pageData);

	//if on client, try finding token in URL and compare it to page's token
	if (isRestricted && location) {
		let _client_token = findQueryParameter(location.search, "token");
		if (_client_token) {
			let response = await fetchAs({
				endpoint: `restrict_page/${nid}|${_client_token}`,
				testing: true,
				extraParams: { useDefaultJsonApiPath: false },
			});
			if (response && response.data) {
				return response.data !== 1 ? isRestricted : false;
			}
		}
	}
	return isRestricted;
};
